/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import moment from "moment-business-days";
import { toast } from "react-toastify";
import Timeout from "await-timeout";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import useFetcher from "../../../hooks/useFetcher";
import { handleErrors } from "../../../services/handleErrors";
import { getCandidatosByNP, postCandidatoNP } from "../../../services/candidatosNPServices";
import { calcularFechaHabil } from "../../../pages/NotasDePedido/utils";
import NewCandidatoFormModal from "../../CandidatosNP/newCandidato/newCandidatoNpModal";
import { CustomLabel } from "../../../ui/labels";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { LabSelect } from "../../course/select";
import { ButtonPrimary } from "../../../ui/buttons";
import { InputText } from "../../../ui/inputs";
import { formatearFecha } from "../../CandidatosNP/utils";
import ExistingCandidateModal from "../../CandidatosNP/existingCandidatoModal";

export const getClosestDate = (fechaAbiertaNP, servicio) => {
  const currentDate = moment().startOf("day");
  const twoBusinessDaysAgo = moment(currentDate).businessSubtract(3)._d;
  const fiveBusinessDaysAgo = moment(currentDate).businessSubtract(5)._d;
  const fechaAbierta = moment(fechaAbiertaNP, "YYYY-MM-DD");
  const diffTwoBusinessDaysAgo = Math.abs(currentDate.diff(twoBusinessDaysAgo, "days"));
  const diffFiveBusinessDaysAgo = Math.abs(currentDate.diff(fiveBusinessDaysAgo, "days"));
  const diffFechaAbierta = Math.abs(currentDate.diff(fechaAbierta, "days"));

  if (fechaAbiertaNP === "Invalid date") {
    return currentDate;
  }

  // si la nota tiene servicio 1 (PP) la derivacion puede tener como fecha hasta 5 dias habiles
  // anteriores a  la fecha actual
  if (servicio === 1) {
    if (diffFiveBusinessDaysAgo <= diffFechaAbierta) {
      return fiveBusinessDaysAgo;
    }
  } else if (diffTwoBusinessDaysAgo <= diffFechaAbierta) {
    return twoBusinessDaysAgo;
  }

  return fechaAbierta;
};

const FormNuevaDerivacion = ({
  toggle,
  id,
  vacantes,
  handleCreateDerivacion,
  cobertura,
  fechaAbierta,
  setReloadCandidatos,
  idsCandidatosDerivados = [],
  servicio,
  candidatosDesdeMultiSelect,
  // setCandidatosDesdeMultiSelect,
  uploadOrPatchFilesCV,
}) => {
  const fechaActual = moment().format("YYYY-MM-DD");
  const fechaAbiertaNP = moment(fechaAbierta).format("YYYY,MM,DD");
  const [fechaDerivacionValue, setFechaDerivacionValue] = useState(fechaActual);
  const [candidatos, isLoadingCandidatos, , , fetchCandidatos] = useFetcher(getCandidatosByNP, [id]);
  const [candidatosADerivar, setCandidatosADerivar] = useState([]);
  const [candidatosList, setCandidatosList] = useState([]);
  const [candidatosModal, setCandidatosModal] = useState(false);
  const [coberturaManual, setCoberturaManual] = useState(false);
  const [candidatosCantidad, setCandidatosCantidad] = useState(0);
  const [fechaDeIngresoValue, setFechaDeIngresoValue] = useState(null);
  const [showExistingcandidate, setShowExistingcandidate] = useState(false);
  const [existingCandidateInfo, setExistingCandidateInfo] = useState({});
  const [descartarCandidatoRepetidos, setDescartarCandidatoRepetidos] = useState(null);

  useEffect(() => {
    if (descartarCandidatoRepetidos) {
      const candidatoADescartarId = descartarCandidatoRepetidos[0].id;
      setCandidatosList(candidatosList.filter((candidato) => candidato.id !== candidatoADescartarId));
      setCandidatosADerivar(candidatosADerivar.filter((candidato) => candidato.value.id !== candidatoADescartarId));
      fetchCandidatos();
      setReloadCandidatos(true);
    }
    setDescartarCandidatoRepetidos(null);
  }, [descartarCandidatoRepetidos]);

  useEffect(() => {
    if (candidatosDesdeMultiSelect.length > 0) {
      const filteredCandidatos = candidatosDesdeMultiSelect.filter((candidato) => {
        return !idsCandidatosDerivados.includes(candidato.candidatoId);
      });
      if (filteredCandidatos.length === 0 && candidatosDesdeMultiSelect.length > 0) {
        // si todos los candidatos elegidos han sido derivados
        toast.error("Los candidatos seleccionados ya han sido derivados");
        return;
      }
      const selectedCandidatos = filteredCandidatos.map((candidato) => {
        return { label: `${candidato.candidato.nombre} ${candidato.candidato.apellido}`, value: { id: candidato.candidatoId } };
      });
      const selectedCandidatosIds = filteredCandidatos.map((candidato) => {
        return { id: candidato.candidatoId };
      });
      setCandidatosList([...candidatosList, ...selectedCandidatosIds]);
      setCandidatosADerivar([...candidatosADerivar, ...selectedCandidatos]);
    }
  }, [candidatosDesdeMultiSelect]);

  useEffect(() => {
    if (candidatosList.length) {
      setCandidatosCantidad(candidatosList.length);
    }
  }, [candidatosList]);

  const handleAddCandidato = async (candidatoData, files) => {
    try {
      const { message, result, repetidos } = await postCandidatoNP(candidatoData);
      if (repetidos) {
        toast.warn(message);
        setExistingCandidateInfo(result);
        setShowExistingcandidate(true);
      } else {
        if (files) await uploadOrPatchFilesCV(result.id, files);
        toast.success(message);
      }

      const label = repetidos ? `${candidatoData.nombre} ${candidatoData.apellido}` : `${result.nombre} ${result.apellido}`;
      const value = repetidos ? { id: result[0].id } : { id: result.id };
      setCandidatosList([...candidatosList, value]);
      setCandidatosADerivar([...candidatosADerivar, { label: `${label}`, value }]);
      fetchCandidatos();
      setReloadCandidatos(true);
      return true;
    } catch (error) {
      toast.error(error.message);
      return false;
    }
  };

  const candidatosFiltrados = candidatos.filter((candidato) => {
    return !idsCandidatosDerivados.includes(candidato.candidatoId);
  });

  const candidatosOptions = candidatos
    ? candidatosFiltrados
        .map((e) => {
          return { label: `${e.candidato.nombre} ${e.candidato.apellido}`, value: { id: e.candidatoId } };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const opcionesDisponibles = candidatosOptions.filter((opcion) => {
    return !candidatosADerivar.some((candidato) => candidato.value.id === opcion.value.id);
  });

  const handleReactSelectChange = (selected) => {
    setCandidatosADerivar(selected);
    setCandidatosList(selected.map((e) => e.value));
  };

  // const handleDeleteCandidato = (cuil) => {
  //   const newCandidatosList = candidatosList.filter((objeto) => objeto.cuil !== cuil);
  //   setCandidatosList(newCandidatosList);
  // };

  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaDerivacionValue(fechaFormateada);
  };

  const handleDatesChangeIngreso = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaDeIngresoValue(fechaFormateada);
  };

  const formik = useFormik({
    initialValues: {
      notaDePedidoId: id,
      fechaDerivacion: "",
      candidatos: "",
      cubiertas: 0,
      estado: "pendiente",
      candidatosDetalle: [{}],
    },

    onSubmit: async (values) => {
      const dataToDerivacion = {
        ...values,
        cubiertas: JSON.parse(values.cubiertas ? values.cubiertas : "0"),
        candidatos: values.candidatos ? JSON.parse(values.candidatos) : candidatosCantidad,
        candidatosDetalle: candidatosList,
        fechaDerivacion: fechaDerivacionValue,
        fechaDeIngreso: fechaDeIngresoValue || null,
      };

      try {
        handleCreateDerivacion(dataToDerivacion);
        await Timeout.set(1000);
        toggle();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      candidatos: Yup.number(),
      cubiertas: Yup.number().test("cubiertas", "El número de cubiertos  no puede superar a las vacantes solicitadas", (value) => {
        return value <= vacantes - cobertura;
      }),
    }),
  });

  return (
    <>
      {showExistingcandidate && (
        <ExistingCandidateModal
          isOpen={showExistingcandidate}
          toggle={() => setShowExistingcandidate(!showExistingcandidate)}
          info={existingCandidateInfo}
          notaDePedidoId={id}
          setReloadCandidatos={setReloadCandidatos}
          setDescartarCandidatoRepetidos={setDescartarCandidatoRepetidos}
        />
      )}
      <form className="theme-form" onSubmit={formik.handleSubmit}>
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-sm-9">
            <StylesDatePicker className="mb-1">
              <CustomLabel htmlFor="fechaDerivacion" className="pt-0 w-100">
                Fecha de derivación
                <DatePicker
                  className="date-input digits w-100"
                  dateFormat="AAAA-MM-dd"
                  onChange={handleDatesChange}
                  disabled={formik.isSubmitting}
                  value={formatearFecha(fechaDerivacionValue)}
                  selected={fechaDerivacionValue ? new Date(fechaDerivacionValue).setDate(new Date(fechaDerivacionValue).getDate() + 1) : null}
                  maxDate={new Date()}
                  minDate={new Date(getClosestDate(fechaAbiertaNP, servicio))}
                />
              </CustomLabel>
            </StylesDatePicker>
          </div>
          <div className="col-sm-9">
            <div className="mb-3 mt-3">
              <CustomLabel htmlFor="candidatos" className="pt-0 w-100 d-flex">
                Cobertura por candidatos
                <input
                  type="checkbox"
                  name="cubiertas"
                  onChange={() => setCoberturaManual(!coberturaManual)}
                  disabled={formik.isSubmitting}
                  checked={!coberturaManual}
                  className="checkbox_animated ml-2"
                />
              </CustomLabel>
            </div>
          </div>
          {candidatosModal && (
            <NewCandidatoFormModal
              isOpen={candidatosModal}
              toggle={() => setCandidatosModal(!candidatosModal)}
              handleCreateCandidato={handleAddCandidato}
              notaDePedidoId={id}
            />
          )}
          {coberturaManual ? (
            ""
          ) : (
            <div className="col-sm-9">
              <div className="form-group">
                <CustomLabel htmlFor="candidatosDetail" className="pt-0 w-100">
                  Candidatos
                  <LabSelect
                    isMulti
                    id="candidatosDetail"
                    name="candidatosDetail"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={candidatosADerivar}
                    placeholder="Seleccionar candidatos"
                    isClearable
                    isLoading={isLoadingCandidatos}
                    isDisabled={isLoadingCandidatos}
                    options={opcionesDisponibles}
                  />
                  <div className=" mt-3 mb-0 d-flex justify-content-end">
                    <ButtonPrimary onClick={() => setCandidatosModal(!candidatosModal)} type="button">
                      Agregar otro
                    </ButtonPrimary>
                  </div>
                </CustomLabel>
              </div>
            </div>
          )}
          {coberturaManual ? (
            <>
              <div className="col-sm-9">
                <div className="form-group">
                  <CustomLabel htmlFor="candidatos" className="py-0 w-100">
                    Candidatos
                    <InputText
                      className="w-100"
                      // type="number"
                      name="candidatos"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.candidatos}
                    />
                  </CustomLabel>
                  {formik.errors.candidatos && formik.touched.candidatos && <CustomLabel style={{ color: "red" }}>{formik.errors.candidatos}</CustomLabel>}
                </div>
              </div>
              <div className="col-sm-9">
                <div className="form-group">
                  <CustomLabel htmlFor="cubiertas" className="col-form-label py-0 w-100">
                    Cubiertos
                    <InputText
                      className="w-100"
                      // type="number"
                      name="cubiertas"
                      placeholder="cantidad de cubiertos"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.cubiertas}
                    />
                  </CustomLabel>
                  {formik.errors.cubiertas && formik.touched.cubiertas && <CustomLabel style={{ color: "red" }}>{formik.errors.cubiertas}</CustomLabel>}
                </div>
              </div>

              <div className="col-sm-9">
                <StylesDatePicker className="mb-1">
                  <CustomLabel htmlFor="fechaAbierta" className="pt-0 w-100">
                    Fecha de ingreso
                    <DatePicker
                      placeholder="fecha de ingreso"
                      className=" date-input digits w-100"
                      dateFormat="AAAA-MM-dd"
                      onChange={handleDatesChangeIngreso}
                      disabled={formik.isSubmitting}
                      value={fechaDeIngresoValue}
                      selected={fechaDeIngresoValue ? new Date(fechaDeIngresoValue).setDate(new Date(fechaDeIngresoValue).getDate() + 1) : null}
                      minDate={new Date(calcularFechaHabil(fechaActual, -1))}
                    />
                  </CustomLabel>
                </StylesDatePicker>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        <div className=" mt-3 mb-0 d-flex justify-content-end">
          <Button
            color="btn-secondary mr-2"
            onClick={() => {
              toggle();
              // setCandidatosDesdeMultiSelect([]);
            }}
          >
            Cancelar
          </Button>
          <ButtonPrimary isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="submit">
            Crear Derivación
          </ButtonPrimary>
        </div>
      </form>
    </>
  );
};

export default FormNuevaDerivacion;
